/**
 * Strips the locale suffix @nuxtjs/i18n appends to every route name ("sessions___fr" → "sessions"),
 * so a route can be compared to its page name. Without this, `route.name === "sessions"` is dead
 * code and callers silently fall into their fallback branch.
 */
export function routeBaseName(name: unknown): string {
  return typeof name === "string" ? (name.split("___")[0] ?? "") : "";
}
